import { css } from "styled-components";

export const deleteActionStyle = css`
  color: var(--text-light);
  background-color: var(--error);
  font-weight: var(--font-weight-semi-bold);

  svg path {
    fill: transparent !important;
    stroke: var(--text-light) !important;
  }

  &:hover {
    background-color: var(--error) !important;
    color: var(--text-light) !important;
    opacity: 0.9;

    svg path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &:focus {
    outline: none !important;
    color: var(--text-light) !important;
    background-color: var(--error) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &:active {
    background-color: var(--error) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &[disabled] {
    color: var(--text-light);
    background-color: var(--error);
    opacity: 0.5;

    &:hover {
      color: var(--text-light);
      background-color: var(--error);
      opacity: 0.5;
    }
  }
`;
